// extracted by mini-css-extract-plugin
module.exports = {"admin":"Charges_admin__27j5K","complementaryText":"Charges_complementaryText__X5_UC","title":"Charges_title__1V9kf"};